(function () {
  const bar = document.getElementById('sticky-atc-bar');
  const btn = document.getElementById('sticky-atc-btn');
  const priceEl = document.getElementById('sticky-atc-price');

  // The native submit button inside the product form
  const nativeBtn = document.querySelector('[data-type="add-to-cart-form"] [name="add"]');

  if (!bar || !btn || !nativeBtn) return;

  // Show bar when native ATC scrolls out of view
  const observer = new IntersectionObserver(
    ([entry]) => {
      const visible = !entry.isIntersecting;
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', String(!visible));
    },
    { threshold: 0 }
  );
  observer.observe(nativeBtn);

  // Clicking sticky button triggers the real form button
  // This preserves Dawn's loading state, cart drawer, error handling
  btn.addEventListener('click', () => {
    nativeBtn.click();
  });

  // Sync on variant change
  // Dawn's variant-radios and variant-selects dispatch this on document
  document.addEventListener('variant:change', (e) => {
    const variant = e?.detail?.variant;

    if (!variant) {
      btn.disabled = true;
      btn.textContent = 'Unavailable';
      return;
    }

    const available = variant.available;
    btn.disabled = !available;
    btn.textContent = available ? 'Add to cart' : 'Sold out';

    if (priceEl && variant.price) {
      priceEl.textContent = '₹' + (variant.price / 100).toLocaleString('en-IN');
    }
  });
})();